export default "__VITE_ASSET__CLRjEqn8__"